import connectHits from './connectHits.js';
import withInsights from '../../lib/insights/client.js';

var connectHitsWithInsights = withInsights(connectHits);

export { connectHitsWithInsights as default };
